import enMessages from 'ra-language-english'
import ptBrMessages from './ra-language-pt-br'
import polyglotI18nProvider from 'ra-i18n-polyglot'

import CustomPtBR from './pt-br'

const messages = {
  'pt-br': {
    ...ptBrMessages,
    ...enMessages,
    ...CustomPtBR,
  },
}
export const i18nProvider = polyglotI18nProvider(
  (locale) => messages[locale],
  'pt-br',
  { allowMissing: true },
)
